import { render } from "./AssetsList.m.vue?vue&type=template&id=9d6df324"
import script from "./AssetsList.m.vue?vue&type=script&lang=js"
export * from "./AssetsList.m.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__